export const TITLE = '4PL物流协同平台';
export const TOKEN_KEY = 'permissionAuthorization';
export const FPL_TOKEN_KEY = 'fplToken';
export const FILESERVICE = process.env.VUE_APP_FILE_SERVERS_URL;
export enum PasswordStateEnum {
  UNEXPIRED = 1,
  WARNING = 2,
  EXPIRED = 3,
  WEAKPASSWORD = 4,
}
